module.exports = require("./fo-DK.d.ts");